webpackJsonp([162898551421021],{

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footer = __webpack_require__(121);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _TitleAndMetaTags = __webpack_require__(69);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return Glamor.createElement(
	    "div",
	    { className: "four-oh-four-page page-wrap" },
	    Glamor.createElement(_TitleAndMetaTags2.default, { title: "Aaron Ong - Full Stack Developer" }),
	    Glamor.createElement(
	      "h1",
	      { className: "page-title" },
	      "404"
	    ),
	    Glamor.createElement(
	      "div",
	      { className: "page-content" },
	      Glamor.createElement(
	        "p",
	        null,
	        "You just hit a route that doesn't exist... the sadness :"
	      )
	    ),
	    Glamor.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-afd38d6dedf5ca222677.js